__turbopack_context__.v({
  "button": "CopyButton-module-scss-module__K7h1MW__button",
  "icon": "CopyButton-module-scss-module__K7h1MW__icon",
});
